module.exports = __webpack_public_path__ + "static/media/c09-logo.3ecab7ed.png";